import { svgRectToOverlayPct, type OverlaySpriteTarget } from './modifierOverlayCoords';

/** Масштаб спрайта дерева относительно layout SVG. */
const SVAMI_OVERLAY_SIZE_SCALE = 2;
/** Сдвиг вверх по экрану (отрицательный = выше). */
const SVAMI_OVERLAY_Y_NUDGE_PCT = -1;

export type SvamiOverlaySprite = OverlaySpriteTarget & {
  id: string;
  srcKey: 'svami_m';
};

const svamiTreeBase = svgRectToOverlayPct(6812.72, 664.01, 1491.5, 1236.17);

/** From svami/obstacles/m.png (replaces former groups `1`..`3`). */
export const SVAMI_OVERLAY_SPRITES: readonly SvamiOverlaySprite[] = [
  {
    id: 'svami_m',
    srcKey: 'svami_m',
    xPct: svamiTreeBase.xPct,
    yPct: svamiTreeBase.yPct + SVAMI_OVERLAY_Y_NUDGE_PCT,
    widthPct: svamiTreeBase.widthPct * SVAMI_OVERLAY_SIZE_SCALE,
    heightPct: svamiTreeBase.heightPct * SVAMI_OVERLAY_SIZE_SCALE,
  },
] as const;
